import type { SellerLocationAccess } from '@/api/stock';

export function canUseSellerProductionLocation(
  location: Pick<SellerLocationAccess, 'can_assemble' | 'supports_production'> | null | undefined,
): boolean {
  return Boolean(location?.can_assemble && location.supports_production === true);
}
